import Register from '@/views/Register';

export default [
    {
        path: '/register/',
        name: 'Register',
        component: Register,
        meta: {
            disallowAuthed: true,
        },
    },
];
